import store from '../Store'
import * as routeService from './routeService'
import { logoutUser } from '../actions/AuthAction'
import { selectAccessToken, selectIsAuthenticated } from '../selectors/authSelector'

export const isUserAuthenticated = () => {
  return selectIsAuthenticated(store.getState())
}

export const userAuthPresent = () => {
  return selectIsAuthenticated(store.getState())
}

export const getUserToken = () => {
  return selectAccessToken(store.getState())
}

export const getStoredUserData = () => {
  return store.getState().AuthReducer.user
}

export const logOutUser = () => {
  store.dispatch(logoutUser())
  routeService.goToLoginPage()
}

export const isUserDataValid = () => {
  const { firstname, lastname, email, unverifiedEmail } = store.getState().AuthReducer.user
  return firstname && lastname && (email || unverifiedEmail)
}

export const isUserPhoneVerified = () => {
  const { unverifiedPhone } = store.getState().AuthReducer.user
  return !unverifiedPhone
}

export const firstPhaseSubmited = () => {
  const step = store.getState().FlowReducer.step
  const completedAt = store.getState().FlowReducer.completedAt

  return step == 1 && completedAt !== null
}

export const firstPhaseOnGoing = () => {
  const step = store.getState().FlowReducer.step
  const completedAt = store.getState().FlowReducer.completedAt

  return (step == 1 && completedAt !== null) || (step == 0 && completedAt !== null)
}

export const secondPhaseOnGoing = () => {
  const step = store.getState().FlowReducer.step
  const completedAt = store.getState().FlowReducer.completedAt

  return step == 2 && completedAt !== null
}



// WEBPACK FOOTER //
// ./src/services/userService.js